export default __webpack_public_path__ + "static/media/FarmingExtensionGen1Template.73736384.sol";